module.exports = __webpack_public_path__ + "static/media/portfolio.fc1308bb.svg";